import React, { Component } from "react";
import LandingPage from "../../components/LandingPage";
// import Branch from "../../components/Branch";
// import UserDetail from "../../components/UserDetail";
// import VehicleOnboard from "../../components/VehicleOnboard";
// import RiderRegister from "../../components/RiderRegister";
// import Address from "../../components/Address";
import BookingCards from "../../components/BookingCards";
import OperatorsCards from "../../components/OperatorsCards";
import VinList from "../../components/VinModerationListing";
import VinDetailPopup from "../../components/VinModerationDetailPopup";
import RidesReportsListing from "../../components/RidesReportsListing";
import EventsReportsListing from "../../components/EventsReportsListing";
import BranchReportsListing from "../../components/BranchReportsListing";
import ActivityToursLandingPage from "../../components/ActivityToursLandingPage";
// import ToursPersonalInformation from "../../components/ToursPersonalInformation";
import PartnerPersonalForm from "../../components/PartnerPersonalForm";
import ToursList from "../../components/ToursList";
import ToursDetails from "../../components/TourDetails";
import ExperienceList from "../../components/ExperienceList";
import AddNewTour from "../../components/AddNewTour";
import ExperienceDetail from "../../components/ExperienceDetail";
import AddNewExperience from "../../components/AddNewExperience";
import TestimonialList from "../../components/TestimonialsList";
// import TestimonialDetails from "../../components/TestimonialDetails";
import AddNewTestimonial from "../../components/AddNewTestimonial";
import Rentals from "../../components/Rentals";
import TestimonialQueue from "../../components/TestimonialQueue";
import ToursQueue from "../../components/ToursQueue";
import PartnersList from "../../components/PartnersList";
import PartnerDetails from "../../components/PartnerDetails";
import AdminJourneyPage from "../../components/AdminJourneyPage";

// import RideDetail from "../../components/RideDetail"
// import RiderMembershipListing from "../../components/RiderMembershipListing"
class Testing extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    return (
      <React.Fragment>
        {/* <Branch /> */}
        {/* <UserDetail /> */}
        {/* <VehicleOnboard /> */}
        {/* <RideDetail /> */}
        {/* <Loader /> */}
        {/* <RiderMembershipListing /> */}
        {/* <Address /> */}
        {/* <BookingCards /> */}
        {/* <OperatorsCards /> */}
        {/* <VinList /> */}
        {/* <VinDetailPopup /> */}
        {/* <RidesReportsListing /> */}
        {/*  <ActivityToursLandingPage/>  {/* Sneha created this */}
         {/* <ToursPersonalInformation/> {/* Sneha created this */}
         {/*  <PartnerPersonalForm/>  {/* Sneha created this */}
       {/* <ToursList/>  {/* Sneha created this */}
         <ToursDetails/>  {/* Sneha created this */}
        {/*<AddNewTour /> {/* Sneha created this */}
          {/*<ExperienceList /> {/* Sneha created this */}
        {/* <ExperienceDetail />  {/* Sneha created this */}
        {/* <AddNewExperience />  {/* Sneha created this */}
         {/* <TestimonialList />  {/* /Sneha created this */}
        {/* <TestimonialDetails /> {/* /Sneha created this */}
         {/* <AddNewTestimonial /> {/* /Sneha created this */}
        {/*  <Rentals /> {/* /Sneha created this */}
        {/* <TestimonialQueue />  {/* /Sneha created this */}
       {/* <ToursQueue />  {/* /Sneha created this */}
          {/* <PartnersList />  {/* /Sneha created this */}
         {/*<PartnerDetails />  {/* /Sneha created this */}
        {/* <AdminJourneyPage />  {/* /Sneha created this */}
        {/* <EventsReportsListing /> */}
        {/* <BranchReportsListing /> */}
      </React.Fragment>
    );
  }
}

export default Testing;
